<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>



    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title>Bilanço Raporu</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              flat=""
              solo-inverted=""
              hide-details
              v-model="search"
              :label="$t('Search')"
              append-icon="search"
            >
            </v-text-field>

            <v-menu offset-y>
              <v-btn slot="activator" dark icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile @click="getListExcel()">
                  <v-list-tile-title
                    >Excel {{ $t("Download") }}</v-list-tile-title
                  >
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-flex>
<v-container fluid>
  <v-form ref="muhasebehesabagore" v-model="valid">
              <v-layout row wrap="">
              
                <v-flex xs12 sm6 md3>
                  <v-select  clearable :items="donemler" label="Dönem" item-text="text" item-value="value" v-model="prmDonem" >

</v-select>
                </v-flex>

                <v-flex xs12 sm6 md2>
                  <v-select  clearable :items="bilancoTipleri" label="Bilanço Tip" item-text="text" v-model="prmBilancoTipi" item-value="value">

</v-select>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-autocomplete hide-details :items="masrafmerkezi" clearable v-model="prmMasrafMerkezleri" :label="$t('Expense-Center-v2')" multiple item-text="Title" item-value="Code">
                                                            <template slot="selection" slot-scope="{ item, index }">
                                                                <div v-if="index === 0">
                                                                    <span>{{ item.Code }}</span>
                                                                </div>
                                                                <span v-if="index === 1" class="grey--text caption">(+{{
                                                              prmMasrafMerkezleri.length -
                                                                1
                                                                }} {{$t('Other')}} )</span>
                                                            </template>
                                                        </v-autocomplete>
                </v-flex>
               
                <v-flex xs12 sm12 md2>
              <v-checkbox v-model="prmKapanisFisiDahil"
      label="Kapanış Fişini Dahil Etme" false-value="0"
    true-value="1"
    ></v-checkbox>
            </v-flex>
                <v-flex xs12 sm12 md1>
                  <v-layout>
                    <v-btn color="info" @click="getList()" fab small="" dark>
                      <v-icon>search</v-icon>
                    </v-btn>

                 
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-form>
</v-container>
       

        <v-container fluid="">
          <v-card color="grey lighten-5" flat>
           
            <v-layout>
              <v-flex xs12 sm12 md12 pt-2>
                <v-card flat>
                  <v-data-table
                    :headers="headers"
                    class="elevation-1"
                    :items="items"
                    :search="search"
                    hide-actions
                  >
                 
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-left">
                        {{ props.item.Kod  }}
                      </td>
                      <td class="text-xs-left">
                        <div :class="getStyle(props.item.Aciklama)">{{ props.item.Aciklama }}</div>
                       
                      </td>
                      <td class="text-xs-left">
                        <div :class="getStyle(props.item.Aciklama)">{{ props.item.OncekiDonem }}</div>
                        
                      </td>
                      <td class="text-xs-left">
                        <div :class="getStyle(props.item.Aciklama)"><div v-if="props.item.CariDonem!=''">{{ moneyformat(props.item.CariDonem) }}</div></div>
                      </td>
                     
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card>
        </v-container>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import tarihcomp from "../../customcomp/tarihim";
import auth from "../../../../api/auth";
import catimuhasebekodu from "../comp/catimuhasebekodu.vue";

export default {
  data() {
    return {
      prmYil:2024,
      prmDonem:1,
      prmBilancoTipi:0,
      prmMasrafMerkezleri:[],
      prmKapanisFisiDahil:0,
      yillar:[
    {
          text: "2024",
          value:2024
     },
     {
      text: "2023",
      value:2023
     },
    
    
    ],
      bilancoTipleri:[
    {
          text: "Ayrıntılı Bilanço",
          value:0
     },
     {
      text: "Özet Bilanço",
      value:1
     },
     {
      text: "Sıfır Hesaplar Hariç",
          value:2
     },
    
    ],
      donemler:[
    {
          text: "OCAK",
          value:1
     },
     {
      text: "OCAK - ŞUBAT",
      value:2
     },
     {
      text: "OCAK - MART",
      value:3
     },
     {
      text: "OCAK - NİSAN",
      value:4
     },
     {
      text: "OCAK - MAYIS",
      value:5
     },
     {
      text: "OCAK - HAZİRAN",
      value:6
     },
     {
      text: "OCAK - TEMMUZ",
      value:7
     },
     {
      text: "OCAK - AĞUSTOS",
      value:8
     },
     {
      text: "OCAK - EYLÜL",
      value:9
     },
     {
      text: "OCAK - EKİM",
      value:10
     },
     {
      text: "OCAK - KASIM",
      value:11
     },
     {
      text: "OCAK - ARALIK",
      value:12
     },
    ],
    masrafmerkezi: [],
    dovizTipleri:[
    {
          text: "TL",
          value:0
     },
     {
          text: "Döviz",
          value:1
     },
     {
          text: "Döviz + TL",
          value:3
     },
    ],
      
      search: null,
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      valid: true,
      searchParams: {
        CompanyID: 0,
        FirstDate: null,
        EndDate: null,
        FirstAccountCode: null,
        EndAccountCode: null,
        ExtractType :0,
        ExcludeClosingFiche :0
      },
      accoutingCode: {
        CodeID: 0,
        CompanyID: 0,
        Code: null,
        CodeName: null,
        Text: null,
      },
      endAccoutingCode: {
        CodeID: 0,
        CompanyID: 0,
        Code: null,
        CodeName: null,
        Text: null,
      },
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
      items: [],
     
     
      headers: [
        {
          text: 'Kod',
        },
        {
          text: 'Tanım',
        },
        {
          text: 'Önceki Dönem',
        },
        {
          text: 'Cari Dönem',
        },
      
      ],
    };
  },
  methods: {
    getStyle (calories) {
     
      if ( calories.includes('*')) return 'font-weight-bold'
      else return ''
    },
    getExpenseCenters(){

var params={
  SourceCompanyID :this.credentials.SirketKodu,
}
this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
    headers: {
      'Authorization': 'Bearer ' + auth.getAuthHeader()
    }
  }).then((response) => {
    this.masrafmerkezi = response.body
  }, (response) => {
    if (response.status === 0) {
      this.text1 = 'Service Unavailable-Masraf Merkezi'
      this.snackbar = true
    } else {
      this.text1 = 'Service Unavailable-Masraf Merkezi'
      this.snackbar = true
    }
  })
},
   
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
  
    getparabirimi() {
      return helpers.getparabirimi();
    },
   
    getList() {
    
      
      var yil=this.prmYil;

      var gun = new Date(yil, this.prmDonem , 0).getDate();

      var basla=yil + '-' + '1' + '-' + '1';
      var bitis=yil + '-' + this.prmDonem + '-' + gun;
     

     
    this.items=[];
      this.loadingvmodel=true;
    var costcenters=this.prmMasrafMerkezleri;
    if (this.prmMasrafMerkezleri.length==0)
    {
      costcenters=null;
    }
   
      let params = {
        CompanyID: this.credentials.MuhasebeSirketNo,
        DateStart: basla,
        DateEnd: bitis,
        ExcludeClosingFiche: this.prmKapanisFisiDahil,
        CostCenter: costcenters,
        Type:this.prmBilancoTipi,
      };
     
          this.$http
            .post(
              auth.API_URL + "api/AccountingReports/StatementReport",
              params,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              }
            )
            .then(
              (response) => {

                if (response.body.Status==false)
                {
                  this.text1 = response.body.ResponseMessage;
                  this.snackbar = true;
                  this.loadingvmodel=false;
                  return;
                }

                console.log(response.body.Pasifler);
                this.items.push(
                        {
                          Kod:'' ,
                          Aciklama:'AKTİF VARLIKLAR',
                          OncekiDonem:'',
                          CariDonem: ''

                        }
                      )
                for(
                        let tindex =0 ;
                        tindex<response.body.Aktifler.Varliklar.lines.length;
                        tindex++
                      ){
                        const d = response.body.Aktifler.Varliklar.lines[tindex];
                        this.items.push(
                        {
                          Kod:d.Kebir ,
                          Aciklama:d.CodeName,
                          OncekiDonem:0,
                          CariDonem: d.Amount

                        }
                      );   
                      }

                      this.items.push(
                        {
                          Kod:'' ,
                          Aciklama:'Aktif Varlıklar Toplam:',
                          OncekiDonem:'',
                          CariDonem: response.body.Aktifler.Varliklar.Total

                        }
                      )
               
                      for(
                        let tindex =0 ;
                        tindex<response.body.Aktifler.Diger.lines.length;
                        tindex++
                      ){
                        const d = response.body.Aktifler.Diger.lines[tindex];
                        this.items.push(
                        {
                          Kod:d.Kebir ,
                          Aciklama:d.CodeName,
                          OncekiDonem:0,
                          CariDonem: d.Amount

                        }
                      );   
                      }


                      this.items.push(
                        {
                          Kod:'' ,
                          Aciklama:'Aktif Toplamı:',
                          OncekiDonem:'',
                          CariDonem: response.body.Aktifler.Total

                        }
                      )
//PASİFLER
this.items.push(
                        {
                          Kod:'' ,
                          Aciklama:'PASİF KAYNAKLAR',
                          OncekiDonem:'',
                          CariDonem: ''

                        }
                      )
                for(
                        let tindex =0 ;
                        tindex<response.body.Pasifler.Kaynaklar.lines.length;
                        tindex++
                      ){
                        const d = response.body.Pasifler.Kaynaklar.lines[tindex];
                        this.items.push(
                        {
                          Kod:d.Kebir ,
                          Aciklama:d.CodeName,
                          OncekiDonem:0,
                          CariDonem: d.Amount

                        }
                      );   
                      }

                      this.items.push(
                        {
                          Kod:'' ,
                          Aciklama:'Pasif Kaynaklar Toplam:',
                          OncekiDonem:'',
                          CariDonem: response.body.Pasifler.Kaynaklar.Total

                        }
                      )
               
                      for(
                        let tindex =0 ;
                        tindex<response.body.Pasifler.Diger.lines.length;
                        tindex++
                      ){
                        const d = response.body.Pasifler.Diger.lines[tindex];
                        this.items.push(
                        {
                          Kod:d.Kebir ,
                          Aciklama:d.CodeName,
                          OncekiDonem:0,
                          CariDonem: d.Amount

                        }
                      );   
                      }


                      this.items.push(
                        {
                          Kod:'' ,
                          Aciklama:'Pasif Toplamı:',
                          OncekiDonem:'',
                          CariDonem: response.body.Pasifler.Total

                        }
                      )




                      this.loadingvmodel=false;
              },
              (response) => {
                if (response.status === 0) {
                  this.text1 = "Service Unavailable";
                  this.snackbar = true;
                  this.loadingvmodel=false;
                } else {
                  this.text1 = "Service Unavailable";
                  this.snackbar = false;
                  this.loadingvmodel=false;
                }
              }
            );
           
     
    },
    getListHtml() {
      var bastarih = new Date(this.searchParams.FirstDate);
      var bittarih = new Date(this.searchParams.EndDate);
      if (bastarih <= bittarih) {
        this.items = [];
        this.itemDetails = [];
        if (this.$refs.muhasebehesabagore.validate()) {
         
          this.searchParams.CompanyID = this.credentials.MuhasebeSirketNo;
          this.searchParams.FirstAccountCode = this.accoutingCode.Code;
          this.searchParams.EndAccountCode = this.endAccoutingCode.Code;
         

          this.$http
            .post(
              auth.API_URL + "api/AccountingReports/ExtractAccountListHtml",
              this.searchParams,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              }
            )
            .then(
              (response) => {
                var blob = new Blob([response.data], {
                  type: "application/html",
                });
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "HesapEkstre.html";
                link.click();
              },
              (response) => {
                if (response.status === 0) {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                } else {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                }
              }
            );
        }
      } else {
        this.text1 = this.$t("start-date-cannot-greater-than-end-date");
        this.snackbar = true;
      }
    },
    LoadParameters() {
      var params = {
        ID: 0,
        CompanyID: this.credentials.MuhasebeSirketNo,
      };
      this.$http
        .post(
          auth.API_URL + "api/AccountingParameters/AccountingParametersLoad",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            var date =new Date(response.body.PeriodEnd); 
            var yil=date.getUTCFullYear();
            this.prmYil=yil;
            
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingParametersLoad";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-AccountingParametersLoad";
              this.snackbar = true;
            }
          }
        );
    },
    getListExcel() {
      this.loadingvmodel=true;
      var costcenters=this.prmMasrafMerkezleri;
   
   if (this.prmMasrafMerkezleri.length==0)
   {
     costcenters=null;
   }

     
      var yil=this.prmYil;
      var gun = new Date(this.prmYil, this.prmDonem , 0).getDate();
      var basla=yil + '-' + '1' + '-' + '1';
      var bitis=yil + '-' + this.prmDonem + '-' + gun;
     
      let params = {
      
        CompanyID: this.credentials.MuhasebeSirketNo,
        DateStart: basla,
        DateEnd: bitis,
        ExcludeClosingFiche: this.prmKapanisFisiDahil,
        CostCenter: costcenters,
        Type:this.prmBilancoTipi,
      };
     
        
          this.$http
            .post(
              auth.API_URL + "api/AccountingReports/StatementReportExcel",
              params,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
                responseType: "arraybuffer",
              }
            )
            .then(
              (response) => {
                var blob = new Blob([response.data], {
                  type: "application/xlsx",
                });
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "Bilanco.xlsx";
                link.click();
                this.loadingvmodel=false;
              },
              (response) => {
                if (response.status === 0) {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                  this.loadingvmodel=false;
                } else {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                  this.loadingvmodel=false;
                }
              }
            );
        
     
    },
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    tarihcomp,
    catimuhasebekodu,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
   
    if (this.sayfayetki.Status == true) {
      this.LoadParameters();
      this.getExpenseCenters();
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
  },
};
</script>

<style>
</style>

